<template>
<transition name="modal">
  <div class="modal-mask modal-area">
    <div class="modal-wrapper">
      <div class="modal-container">


        <b-row class=" no-gutters">
          <b-col class="" cols="12">


            <b-row class=" no-gutters">

              <b-col class="" cols="10">
                <div class="heading-area">
                  <div class="image-div">
                    <div class="quesmark-icon-modal" v-if="userData.isWhatTed"></div>
                    <div class="environment-image " v-if="userData.isEnvironment"></div>
                                        <div class="genetic-image " v-if="userData.isGenetics"></div>
                                        
                                        <div class="gender-image " v-if="userData.isGender"></div>
                  </div>

                  <div class="header-area">
                    <div class="head-txt">
                      <span  v-if="userData.isWhatTed">
                      What is a TED “Flare?”
                      </span>
                      
                        <span  v-if="userData.isEnvironment">
                    Infections/Environment
                      </span>
                      
                        <span  v-if="userData.isGenetics">
                    Genetics
                      </span>
                      
                        <span  v-if="userData.isGender">
                    Gender Hormones/Pregnancy
                      </span>
                      <hr>
                    </div>
                  </div>
                </div>
              </b-col>


              <b-col class="" cols="2">
                <div class="popup-cross " @click="closeModal()"></div>

              </b-col>


            </b-row>

            <b-row class=" body-area no-gutters" :class="{'padding-env': userData.isEnvironment || userData.isGenetics || userData.isGender , 'padding-gender': userData.isGender}">
              <b-col class="" cols="12">
                <span v-if="userData.isWhatTed">
                A TED flare is when TED symptoms appear again after a period of at least 6 months. (Most flares occur within 10 years after the first episode of TED.)
                </span>
                
                  <span v-if="userData.isEnvironment" class="">
                Doctors have known for over 50 years that certain antigens (toxins) are responsible for influencing a person’s autoimmune system and how the body copes with different infections and triggers. 
                <br><br>

There are at least 80 different autoimmune diseases, such as Graves’ disease, TED, lupus and rheumatoid arthritis. People with autoimmune diseases are at risk for relapse (or flares) even after treatment or remission. 
                </span>
                
                   <span v-if="userData.isGenetics" class="">
            Many autoimmune disorders are passed down from parents to their children. Researchers at the National Institute on Aging (NIA) believe there are 89 different variations in human genetics that may be responsible for autoimmune conditions, in which the body’s defense system mistakenly attacks itself. TED progression involves genetics, along with other triggers that may affect each person differently over their lifetime. 
                </span>
                
                  <span v-if="userData.isGender" class="">
            Gender (or sex) hormones control the reproductive system, as well as contribute to the development and activity of the immune system. This may account for the differences in gender-related immune responses. 
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

      </div>
    </div>
  </div>
</transition>

</template>
<script>
/* eslint-disable */
 
  import scrollMixin from '../mixins/scrollMixin';
  import { mapGetters, mapMutations } from 'vuex';
  
export default {
  name: "popupModal",
  components: {
    },
  mixins: [scrollMixin],
   mounted: function() {
      this.scrollToTop();
    },
  
  data() {
    return {
        
     
    };
  },
  
  computed: {
      ...mapGetters('userData', ['userData']),
  },
  
  created() {

    
  },
    
  methods: {
     ...mapMutations('userData', ['saveUserData']),
        closeModal: function() {
if(this.userData.isWhatTed) {
  this.userData.isWhatTed = false;
}
else if(this.userData.isEnvironment) {
  this.userData.isEnvironment = false;
}

else if(this.userData.isGenetics) {
  this.userData.isGenetics = false;
}

else if(this.userData.isGender) {
  this.userData.isGender = false;
}
    },

}
};
</script>

<style lang="scss" scoped>
  
</style>
